import { useTranslation } from 'react-i18next';
import { getCalculatedCommission } from '@/entities/operation';

interface WithdrawTotalSectionProps {
  amount: number;
  assetCode: string;
  fee: number;
  includeFee: boolean;
  precision: number;
}

export function WithdrawModalTotalSection({
  amount,
  assetCode,
  fee,
  includeFee,
  precision,
}: WithdrawTotalSectionProps) {
  const { t } = useTranslation();

  const { totalWithdrawAmountStr, feeStr } = getCalculatedCommission({
    amount,
    includeFee,
    fee,
    assetCode,
    precision,
  });

  return (
    <div className="flex flex-col">
      <div className="p6 text-muted-foreground">
        {t('withdrawMethods.crypto.totalWithdrawTitle')}
      </div>

      <div className="flex justify-between items-center headline2 text-foreground">
        {totalWithdrawAmountStr}
      </div>

      <div className="flex justify-between items-center p6 text-muted-foreground gap-1">
        {t('withdrawMethods.crypto.includingFee')}: {feeStr}
      </div>
    </div>
  );
}
